import React, { useContext, useEffect, useState } from "react";
import AlertTag from "../../Alerts/Alert";
import NavAnchor from "../../Tags/NavAnchor";
import { Button } from "../../ui/button";
import Image from "../../Tags/Image";
import { useQueryParams } from "../../../hooks/useQueryParams";
import { createRecordBatch, getCRMBulkRecords, isCompanyInCRM } from "../../../apis/workspace/general";
import { useMutation } from "react-query";
import SharedDataContext from "../../../SharedDataContext";
import { getPlatformFields } from "../../../apis/workspace/integrations";
import Text from "../../Tags/Text";
import {
  ArrowLeft,
  ArrowRight,
  ChevronRightIcon,
  Cross,
  CrossIcon,
  Eye,
  EyeOff,
  Trash2Icon,
  TrashIcon,
} from "lucide-react";
import SearchFilter from "./SearchFilter";
import CompanyRecords from "./CompanyRecords";
import Input from "../../Tags/Input";
import TableLoader from "../../Loaders/TableLoader";
import { useNavigate, useSearchParams } from "react-router-dom";
import TooltipWrapper from "../../TooltipWrapper";
import { Cross2Icon } from "@radix-ui/react-icons";
import ResponseTable from "./ResponseTable";
import Layout from "../../Layout";
import PeopleOfCompany from "./PeopleOfCompany";
import { createContactsV2, crmBulkSearch, getEnrichmentDetailsById, revealContact } from "../../../apis/ext";
import { useStoreCRMSearch } from "../../../stores/useStoreCRMSearch";
import { useGetCRMSavedConfig } from "../../../apiHooks/useGetCRMSavedConfig";
import { useIntegrations } from "../../../apiHooks/useIntegrations";
import { useStoreIntegrations } from "../../../stores/useStoreIntegrations";
import { createCRMRecords } from "../../../apis/crm";
import toast from "react-hot-toast";
import { useStoreCRMConfig } from "../../../stores/useStoreCRMConfig";
import useUpdateQueryParam from "../../../hooks/useUpdateQueryParam";
import { useCRMCreateRecords } from "../../../apiHooks/useCRMCreateRecords";
import { useStoreCRMCreate } from "../../../stores/useStoreCRMCreate";
import { Alert, AlertTitle } from "../../ui/alert";
import { Badge } from "../../ui/badge";
import { useCaptureEvent } from "../../../hooks/useCaptureEvent";

export default function ContactListOfCompanyToCrm() {
  const {
    savedCRMConfig,
    savedCompanyConfig,
    savedCompanyConfigWithWritePermission,
    savedCompanyConfigObj,
    savedPeopleConfig,
    savedPeopleConfigWithWritePermission,
  } = useStoreCRMConfig();

  const navigate = useNavigate();
  const userData = useContext(SharedDataContext);
  const { activeWorkspace } = userData || {};
  const captureEvent = useCaptureEvent();
  const crmConfigId =
    activeWorkspace?.preferences && activeWorkspace?.preferences?.active_crm_workspace_integration_config_id;

  // final push to CRM payload

  const [pushToCRMPayload, setPushToCRMPayload] = useState([]);
  const updateOrganizationById = (orgId, updates) => {
    setPushToCRMPayload((prev) =>
      prev.map((org) => (org.organization_id === orgId ? { ...org, ...updates } : org))
    );
  };

  const updatePersonById = (personUpdates = []) => {
    setPushToCRMPayload((prev) =>
      prev.map((org) => {
        const updatedChildRequests = org.child_requests.map((child) => {
          const matchedUpdate = personUpdates.find((p) => p.person_id === child.person_id);

          if (matchedUpdate) {
            // Remove person_id from updates before merging
            const { person_id, contact_id, input_fields, ...updates } = matchedUpdate;
            const updatedFields = { ...child, ...updates };
            if (input_fields) {
              updatedFields.input_fields = input_fields;
            } else {
              delete updatedFields.input_fields;
            }
            return { ...updatedFields };
          }

          return child;
        });

        return {
          ...org,
          child_requests: updatedChildRequests,
        };
      })
    );
  };

  const removePersonByRecordId = (recordId) => {
    setPushToCRMPayload((prev) =>
      prev
        .map((org) => ({
          ...org,
          child_requests: (org.child_requests ?? []).filter((c) => c.person_id !== recordId),
        }))
        .filter((org) => org.child_requests.length > 0)
    );

    setBulkRecordDataOrgWise((prev) =>
      prev
        .map((org) => ({
          ...org,
          people: (org.people ?? []).filter(
            (person) => person.person_id !== recordId && person.contact_id !== recordId
          ),
        }))
        .filter((org) => org.people.length > 0)
    );
  };

  const getInitials = (name = "") => {
    if (!name) return "";

    const words = name.trim().split(/\s+/); // split by spaces
    if (words.length === 1) {
      return words[0][0].toUpperCase();
    }

    return (words[0][0] + words[1][0]).toUpperCase();
  };
  const [bulkSearchPayload, setBulkSearchPayload] = useState([]);
  const [bulkRecordPayload, setBulkRecordPayload] = useState([]);
  const query = useQueryParams();
  const [enrichmentDetailsData, setEnrichmentDetailsData] = useState({});
  const [revealedContacts, setRevealedContacts] = useState([]);
  const [queryContacts, setQueryContacts] = useState([]);
  // const [searchParams, setSearchParams] = useSearchParams();
  const [payloadObject, setPayloadObject] = useState();
  const updateQueryParam = useUpdateQueryParam();

  const getParams = () => {
    if (query?.payload && localStorage) {
      const obj = JSON.parse(localStorage.getItem(query?.payload));
      setPayloadObject(obj);

      let contacts = [];
      try {
        contacts = obj.contacts;

        setQueryContacts(contacts);
        const payload = [];
        if (contacts && contacts.length > 0) {
          contacts.forEach((element) => {
            let el = {
              person_id: element?.person_id,
              crm_object_api_name: obj?.crm_object_api_name,
              organization_id: element?.orgSystemId,
              type: "person",
              references: [
                {
                  type: "company",
                  organization_id: element?.orgSystemId,
                },
              ],
              on_create: true,
            };
            if (element.contact_id) {
              el.contact_id = element.contact_id;
            }
            payload.push(el);
          });
        }

        handleGetCRMBulkRecords(payload);
        setBulkRecordPayload(payload);
      } catch (e) {
        console.error("Invalid base64 contact list");
      }
    }
  };

  function updateLocalStorageObject(key, updates = {}) {
    try {
      const existing = JSON.parse(localStorage.getItem(key)) || {};
      const updated = { ...existing, ...updates };
      localStorage.setItem(key, JSON.stringify(updated));
      return updated;
    } catch (error) {
      console.error("Failed to update localStorage object:", error);
      return null;
    }
  }

  useEffect(() => {
    if (activeWorkspace && activeWorkspace.id) {
      setTimeout(() => {
        getParams();
      }, 300);
    }
  }, [query, activeWorkspace]);

  const {
    crmBulkSearchPayload,
    addChunkInCRMBulkSearchData,
    crmBulkSearchData,
    setCRMBulkSearchPayload,
    isCRMBulkSearchLoading,
    isCRMBulkSearchFetched,
    getCRMSearchRecordById,
    getCRMSearchRecordByIdFlat,
  } = useStoreCRMSearch();
  // bulk search
  const isCompanyInCRMFn = useMutation(
    ({ data, configId, options }) =>
      crmBulkSearch({
        data,
        configId,
        options,
        onStream: (chunk) => {
          console.log("📥 Streamed chunk:", chunk);

          addChunkInCRMBulkSearchData(chunk);
        },
      }),
    {
      onError(err) {
        // PostHog: Track CRM search error
        captureEvent("ECRM_BulkContacts_CRMSearchError", {
          error_message: err?.message || "Unknown error",
        });
        console.error("❌ Bulk search stream error:", err);
      },
    }
  );

  const handleIsCompanyInCRM = (payload) => {
    if (isCompanyInCRMFn.isLoading) {
      return;
    }

    setCRMBulkSearchPayload(payload);

    isCompanyInCRMFn.mutate({
      data: payload,
      configId: crmConfigId,

      options: {
        headers: { "X-Workspace-Id": activeWorkspace?.id },
      },
    });
  };
  //

  const updateBulkRecordDataOrgWise = (id, newData) => {
    setBulkRecordDataOrgWise((prev) =>
      prev.map((orgBlock) => {
        // ✅ Case 1: ID matches org-level, update only `name`
        if (orgBlock.organization_id === id) {
          return {
            ...orgBlock,
            name: newData?.name?.value ?? orgBlock.name, // only update `name` key
          };
        }

        const updatedPeople = orgBlock.people.map((person) => {
          if (person.contact_id === id || person.person_id === id) {
            const mergedData = {
              ...person.data, // keep original order
              ...newData, // override existing or add new keys
            };

            return {
              ...person,
              data: mergedData,
            };
          }
          return person;
        });

        return {
          ...orgBlock,
          people: updatedPeople,
        };
      })
    );
  };

  // get bulk records
  const [searchFilter, setSearchFilter] = useState({});
  const [bulkRecordDataOrgWise, setBulkRecordDataOrgWise] = useState([]);
  const [bulkRecordData, setBulkRecordData] = useState([]);
  const [hasReferences, setHasReferences] = useState(false);
  const getCRMBulkRecordsFn = useMutation("get_bulk_record", getCRMBulkRecords, {
    onSuccess(data, variables, context) {
      let hasRefs =
        data && data.length > 0 && data[0].references && data[0].references.length > 0 ? true : false;

      setHasReferences(hasRefs);

      const paramsContacts = payloadObject?.contacts;

      if (!paramsContacts) {
        return;
      }

      const orgInfoMap = new Map();

      // Add both person_id and contact_id as keys
      paramsContacts.forEach((entry) => {
        if (entry.person_id) {
          orgInfoMap.set(entry.person_id.trim(), entry);
        }
        if (entry.contact_id) {
          orgInfoMap.set(entry.contact_id.trim(), entry);
        }
      });

      const uniqueOrgsMap = new Map();

      data.forEach((person) => {
        // const orgInfo = orgInfoMap.get(person.person_id);
        const key1 = person.person_id?.trim();
        const key2 = person.contact_id?.trim();

        // Try to find org info using person_id or contact_id
        const orgInfo = orgInfoMap.get(key1) || orgInfoMap.get(key2);

        if (!orgInfo || !orgInfo.orgSystemId) return;

        const orgKey = orgInfo.orgSystemId;

        if (!uniqueOrgsMap.has(orgKey)) {
          uniqueOrgsMap.set(orgKey, {
            organization_id: orgKey,
            name: orgInfo.orgName,
            linkedin_url: orgInfo.orgLinkedInUrl,
            people: [],
          });
        }

        uniqueOrgsMap.get(orgKey).people.push({ ...person, person_id: orgInfo?.person_id });
      });

      const uniqueOrgs = Array.from(uniqueOrgsMap.values());
      setBulkRecordDataOrgWise(uniqueOrgs);

      const transformedPayload = uniqueOrgs.map((company) => {
        const crmObjectApiName = company.people[0]?.references?.[0]?.crm_object_api_name;
        const matchedObj = company.people[0]?.references?.[0]?.records?.find((el) => el.match_confirmed);
        // const crmRecordId = company.people[0]?.references?.[0]?.records?.[0]?.Id;
        const crmRecordId = matchedObj && matchedObj?.Id ? matchedObj?.Id : "";

        return {
          organization_id: company.organization_id,
          crm_object_api_name: payloadObject?.crm_object_api_name_company,
          type: "company",
          ...(crmRecordId && crmObjectApiName
            ? {
                reference_fields: {
                  [crmObjectApiName]: crmRecordId,
                },
              }
            : {}),

          child_requests: company.people.map((person) => {
            const base = {
              person_id: person.person_id,
              crm_object_api_name: payloadObject?.crm_object_api_name,
              type: "person",
            };

            if (person.contact_id) {
              base.contact_id = person.contact_id;
            }

            return base;
          }),
        };
      });

      console.log("transformedPayload", transformedPayload);

      setPushToCRMPayload(transformedPayload);

      const bulkSearchPayloadCompany = [
        ...new Map(
          paramsContacts.map((el) => [
            el.orgSystemId,
            {
              organization_id: el.orgSystemId,
              type: "company",
              edit_search: false,
            },
          ])
        ).values(),
      ];
      const bulkSearchPayloadPeople = [
        ...new Map(
          paramsContacts.map((el) => {
            const base = {
              person_id: el.person_id,
              type: "person",
              edit_search: false,
            };

            if (el.contact_id) {
              base.contact_id = el.contact_id;
            }

            return [el.person_id, base];
          })
        ).values(),
      ];
      const finalSearchPayload = [...bulkSearchPayloadCompany, ...bulkSearchPayloadPeople];
      setBulkSearchPayload(finalSearchPayload);

      console.log("bulkSearchPayload", finalSearchPayload);
      handleIsCompanyInCRM([...finalSearchPayload]);

      setBulkRecordData(data);
      if (
        data &&
        data.length > 0 &&
        data[0].references &&
        data[0].references.length > 0 &&
        data[0].references[0] &&
        data[0].references[0].search_filters_applied
      ) {
        setSearchFilter(data[0].references[0].search_filters_applied);
      }

      // PostHog: Track bulk records loaded
      captureEvent("ECRM_BulkContacts_BulkRecordsLoaded", {
        records_count: data?.length || 0,
      });
    },
    onError(error) {
      // PostHog: Track bulk records error
      captureEvent("ECRM_BulkContacts_BulkRecordsError", {
        error_message: error?.message || "Unknown error",
      });
      console.log(error);
    },
  });

  const handleGetCRMBulkRecords = (payload) => {
    if (
      (payload && payload.length < 1) ||
      createContactsV2andRevealContacts.isLoading ||
      revealContactFn.isLoading
    ) {
      return;
    }
    getCRMBulkRecordsFn.mutate({
      data: payload,
      configId: crmConfigId,
      options: {
        headers: { "X-Workspace-Id": activeWorkspace?.id },
      },
    });
  };

  // get getPlateformFields

  const [platformFieldsPerson, setPlatformFieldsPerson] = useState([]);
  const getPlatformFieldsFn = useMutation("get_platform_fields", getPlatformFields, {
    onSuccess(data, variables, context) {
      setPlatformFieldsPerson(data?.person);
    },
  });
  const handleGetPlatformFields = () => {
    getPlatformFieldsFn.mutate({
      type: "organizations",
      options: {
        headers: { "X-Workspace-Id": activeWorkspace?.id },
      },
    });
  };

  useEffect(() => {
    if (activeWorkspace && activeWorkspace?.id) {
      handleGetPlatformFields();
    }
  }, [activeWorkspace]);

  function generateKeyLabelArray(inputObj) {
    if (!inputObj) {
      return;
    }

    return Object.keys(inputObj).map((outerKey) => {
      const fieldData = inputObj[outerKey];

      return {
        key: outerKey,
        label: fieldData?.label,
        required: fieldData?.required,
        is_custom: fieldData?.is_custom,
      };
    });
  }

  function getPrintableTableData(systemFields, records) {
    // const headers = systemFields.map((field) => ({
    //   key: field.key,
    //   label: field.label,
    // }));

    const headers = generateKeyLabelArray(records?.[0]?.data);

    const rows = records.map((record) => {
      const row = {};
      const fieldGroup = record.data;
      // 🧠 Go through each header key to extract data from new nested structure
      headers.forEach(({ key, label }) => {
        let found = false;

        if (fieldGroup && fieldGroup[key]) {
          row[key] = fieldGroup[key]?.value;
          found = true;
        }
        if (!found) {
          row[key] = ""; // fallback if key not found
        }
      });

      row.record_id = record?.contact_id || record?.person_id || record?.record_id || "";

      const contacts = payloadObject?.contacts || [];

      const matchedContact = contacts.find((el) => el.id === row.record_id);
      row.isRevealed = matchedContact?.isRevealed;

      return row;
    });

    return { headers, rows };
  }

  const [tableHeads, setTableHeads] = useState([]);
  const [tableRows, setTableRows] = useState([]);
  const [tableRowsWithWithoutIsRevealed, setTableRowsWithWithoutIsRevealed] = useState([]);
  const [tableRowsWithIsRevealed, setTableRowsWithIsRevealed] = useState([]);
  const [tableRowsWithoutIsRevealed, setTableRowsWithoutIsRevealed] = useState([]);

  useEffect(() => {
    if (
      platformFieldsPerson &&
      platformFieldsPerson.length > 0 &&
      bulkRecordData &&
      bulkRecordData.length > 0
    ) {
      const { headers, rows } = getPrintableTableData(platformFieldsPerson, bulkRecordData);

      setTableHeads(headers);

      setTableRows(rows);
      setTableRowsWithWithoutIsRevealed(rows);
      setTableRowsWithIsRevealed(rows.filter((el) => el.isRevealed));
      setTableRowsWithoutIsRevealed(rows.filter((el) => !el.isRevealed));
    }
  }, [platformFieldsPerson, bulkRecordData]);

  const [creatingBatch, setCreatingBatch] = useState(false);

  // create batch record
  const [createBatchRecordResponse, setCreateBatchRecordResponse] = useState({});
  const [tableRowsWithErrorResponse, setTableRowsWithErrorResponse] = useState([]);
  const [tableRowsWithSuccessResponse, setTableRowsWithSuccessResponse] = useState([]);

  const { crmBulkCreatePayload, crmBulkCreateData, getCRMCreateRecordById } = useStoreCRMCreate();

  const { mutate: handleCRMCreate, isLoading: isCRMCreateLoading } = useCRMCreateRecords({
    onStream: (data, variables) => {
      console.log("crmRecords in create chunk push page", data);
      let chunk = JSON.parse(JSON.stringify(data));

      const obj = {
        search_filters_applied: {},
        records: null,
      };
      if (data.data && data.data.length > 0) {
        obj.records = data.data;

        // updateBulkRecordData(data?.contact_id || data?.person_id, data.data[0]);
        if (data?.organization_id) {
          updateBulkRecordDataOrgWise(data?.organization_id, { name: data.data[0]?.name?.value });
        } else {
          updateBulkRecordDataOrgWise(data?.contact_id || data?.person_id, data.data[0]);
        }
        obj.search_filters_applied = {
          name: {
            label: "Account Name",
            value: data.data[0]?.name?.value,
          },
          social_media_urls_linkedin_url: {
            label: "Company Linkedin URL",
            value: data.data[0]?.linkedin_url?.value,
          },
          domain: {
            label: "Domain",
            value: data.data[0]?.domain?.value ? data.data[0]?.domain?.value : "",
          },
        };
      }

      if (data?.contact_id) obj.contact_id = data.contact_id;
      if (data?.person_id) obj.person_id = data.person_id;

      if (data?.person_id || data?.contact_id) {
        obj.crm_object_api_name = payloadObject.crm_object_api_name;
        obj.crm_object_label = payloadObject.crm_object_api_name;
        obj.type = "person";
      }

      if (data?.organization_id) {
        obj.organization_id = data.organization_id;
        obj.crm_object_api_name = payloadObject.crm_object_api_name_company;
        obj.crm_object_label = payloadObject.crm_object_api_name_company;
        obj.type = "company";
      }

      chunk.data = [obj];

      if (data?.crm_response_info?.status === 200) {
        addChunkInCRMBulkSearchData(chunk);
      }
      if (data?.crm_response_info?.status !== 200) {
        addChunkInCRMBulkSearchData(chunk);
        // toast.error(data?.crm_response_info?.error?.description);
      }
    },
    onError: (error) => {},
  });

  const handleCRMCreateFunction = (payload) => {
    switchToRecord("all_records");
    handleCRMCreate({
      data: { requests: payload },
      configId: crmConfigId,
      options: {
        headers: {
          "X-Workspace-Id": activeWorkspace?.id,
          "Record-Source": process.env.REACT_APP_APP_NAME,
        },
      },
    });
  };

  const createRecordBatchFn = useMutation("create_record", createCRMRecords, {
    onSuccess(data, variables, context) {
      // PostHog: Track create records success
      captureEvent("ECRM_BulkContacts_CreateRecordsSuccess", {
        records_count: getCRMRecordPresenceStats()?.notFound,
        companies_count: bulkRecordDataOrgWise?.length,
      });

      navigate(`/${activeWorkspace?.slug}/`);

      toast.success(
        `The records have been created as ${payloadObject?.crm_object_api_name} in the CRM with their companies.`
      );

      // let newdata = data;
      // setCreateBatchRecordResponse(newdata);

      // const responseIds = Object.keys(newdata);

      // const successRecords = tableRowsWithWithoutIsRevealed.filter(
      //   (item) => responseIds.includes(item.record_id) && !newdata[item.record_id].Error
      // );

      // const errorRecords = tableRowsWithWithoutIsRevealed.filter(
      //   (item) => responseIds.includes(item.record_id) && newdata[item.record_id].Error
      // );
      // setTableRowsWithErrorResponse(errorRecords);
      // setTableRowsWithSuccessResponse(successRecords);
    },
    onError(error) {
      // PostHog: Track create records failure
      captureEvent("ECRM_BulkContacts_CreateRecordsFailure", {
        error_message: error?.message || "Unknown error",
      });
      console.log(error);
    },
  });

  const handleCreateBatchRecord = (data) => {
    if (
      isCRMCreateLoading ||
      (data && data.length === 0) ||
      (crmBulkCreateData && crmBulkCreateData.length < crmBulkCreatePayload && crmBulkCreatePayload.length)
    ) {
      return;
    }

    handleCRMCreateFunction(data);
  };

  const handleNavigation = (route) => {
    navigate(`/${activeWorkspace?.slug}${route}`);
  };

  const [skipMissingContacts, setSkipMissingContacts] = useState(false);
  const [skipMissingAlertDismissed, setSkipMissingAlertDismissed] = useState(true);

  useEffect(() => {
    if (skipMissingContacts) {
      setTableRowsWithWithoutIsRevealed(tableRowsWithWithoutIsRevealed.filter((el) => el?.isRevealed));
    }
    console.log("tableRowsWithWithoutIsRevealed", tableRowsWithWithoutIsRevealed);
  }, [skipMissingContacts]);

  useEffect(() => {
    if (tableRowsWithWithoutIsRevealed && tableRowsWithWithoutIsRevealed.length > 0) {
      const arr = tableRowsWithWithoutIsRevealed.filter((el) => !el.isRevealed);
      if (arr && arr.length === 0) {
        setSkipMissingAlertDismissed(true);
      }
    }
  }, [tableRowsWithWithoutIsRevealed]);

  // get saved objects

  const { refetch: refetchIntegrations } = useIntegrations(userData?.activeWorkspace?.id);

  const { setActiveCRMIntegrationById, installedCRMIntegrations, activeCRMIntegration } =
    useStoreIntegrations();

  const getSavedCRMConfigFn = useGetCRMSavedConfig(
    (data) => {
      console.log("CRM config saved:", data);
    },
    (error) => {
      console.error("CRM config failed:", error);
    }
  );

  useEffect(() => {
    if (crmConfigId && installedCRMIntegrations && installedCRMIntegrations.length > 0) {
      let activeCRMobj = installedCRMIntegrations.find((el) => `${el.id}` === `${crmConfigId}`);

      if (activeCRMobj) {
        setActiveCRMIntegrationById(activeCRMobj?.id);
        getSavedCRMConfigFn.mutate({
          crmKey: activeCRMobj?.integration?.key,
          crmConfigId: activeCRMobj?.id,
          options: {
            headers: { "X-Workspace-Id": userData?.activeWorkspace?.id },
          },
        });
      }
    }
  }, [crmConfigId, installedCRMIntegrations]);
  const [contactCreated, setContactCreated] = useState(false);

  useEffect(() => {
    let contactsOfPayload = payloadObject?.contacts || [];

    if (contactsOfPayload && contactsOfPayload.length > 0) {
      const ids = contactsOfPayload.filter((el) => !el.isRevealed).map((el) => el.person_id);
      const notRevealedContactIds = contactsOfPayload
        .filter((el) => !el.isRevealed)
        .map((el) => el.contact_id);

      if (ids && ids.length > 0 && !contactCreated && !query.enrichId) {
        handleCreateContactsV2andRevealContacts(ids);
      }
      if (notRevealedContactIds && notRevealedContactIds.length > 0 && !query.enrichId) {
        handleRevealContact(notRevealedContactIds);
      }
    }
  }, [payloadObject, query, contactCreated]);

  // reveal contact
  const handleCreateContactsV2andRevealContacts = (payload) => {
    const payloadV2 = payload.map((item) => ({ person_id: item }));

    if (createContactsV2andRevealContacts.isLoading) {
      return;
    }
    createContactsV2andRevealContacts.mutate({
      data: {
        contacts: payloadV2,
      },
      options: {
        headers: { "X-Workspace-Id": activeWorkspace?.id },
      },
    });
  };

  const createContactsV2andRevealContacts = useMutation("enrich_profile_2", createContactsV2, {
    onSuccess(data, variables, context) {
      // PostHog: Track contacts created
      captureEvent("ECRM_BulkContacts_ContactsCreated", {
        contacts_count: data?.data?.contacts?.length || 0,
      });

      setContactCreated(true);

      // toast.success(data?.message);
      if (data && data?.data && data?.data?.contacts && data?.data?.contacts.length > 0) {
        let arr = data?.data?.contacts.map((el) => el.contact_id);

        let arrRevealed = data?.data?.contacts.map((el) => ({
          contact_id: el.contact_id,
          person_id: el.person_id,
        }));

        const updatedQueryContacts = queryContacts.map((contact) => {
          const hasObj = arrRevealed.find((i) => i.person_id === contact.person_id);
          if (hasObj && hasObj.person_id) {
            return { ...contact, contact_id: hasObj.contact_id, isRevealed: true };
          }
          return contact;
        });

        // updateQueryParam("contacts", btoa(JSON.stringify(updatedQueryContacts)));
        updateLocalStorageObject(query?.payload, { contacts: updatedQueryContacts });
        const obj = JSON.parse(localStorage.getItem(query?.payload));
        setPayloadObject({ ...obj, contacts: updatedQueryContacts });

        setRevealedContacts(arrRevealed);

        handleRevealContact(arr);
      }
    },
    onError(error) {
      // PostHog: Track contacts create error
      captureEvent("ECRM_BulkContacts_ContactsCreateError", {
        error_message: error?.message || "Unknown error",
      });
      console.log(error);
    },
  });

  const revealContactFn = useMutation("enrich_profile", revealContact, {
    onSuccess(data, variables, context) {
      // PostHog: Track reveal started
      captureEvent("ECRM_BulkContacts_RevealStarted", {
        enrichment_id: data?.data?.id,
      });

      updateQueryParam("enrichId", data?.data?.id);
      setEnrichmentDetailsData(data?.data);
    },
    onError(error) {
      console.log(error);
    },
  });

  const handleRevealContact = (payload) => {
    if (revealContactFn.isLoading) {
      return;
    }
    let arr = [];
    payload.forEach((el) => {
      if (el) {
        let obj = {};
        obj.contact_id = el;
        arr.push(obj);
      }
    });
    if (arr && arr.length === 0) {
      return;
    }

    const construct_payload = {
      settings: {
        verify: ["work_email", "mobile_phone", "personal_email"],
      },
      requirements: ["mobile_phone", "work_email"],
      enrichment_type: "People",
      records: [...arr],
    };
    revealContactFn.mutate({
      data: {
        ...construct_payload,
      },
      options: {
        headers: { "X-Workspace-Id": activeWorkspace?.id },
      },
    });
  };

  const getEnrichmentDetailsByIdFn = useMutation("get_enrichment_details", getEnrichmentDetailsById, {
    onSuccess(data, variables, context) {
      setEnrichmentDetailsData(data?.data);
      if (data?.data?.status === "Completed" || data?.data?.status === "Failed") {
        // PostHog: Track reveal status
        captureEvent("ECRM_BulkContacts_RevealStatus", {
          status: data?.data?.status,
        });
        handleGetCRMBulkRecords(bulkRecordPayload);
      }
    },
    onError(error) {
      console.log(error);
    },
  });
  const handleGetEnrichmentDetailsById = (id = "") => {
    getEnrichmentDetailsByIdFn.mutate({
      id: id,
      options: {
        headers: { "X-Workspace-Id": activeWorkspace?.id },
      },
    });
  };

  useEffect(() => {
    if (query && query.enrichId && activeWorkspace && activeWorkspace.id) {
      handleGetEnrichmentDetailsById(query.enrichId);
    }
  }, [query, activeWorkspace, payloadObject]);

  const handleEnrichmentStatusFailedOrCompleted = (status, reverse) => {
    const isCompletedOrFailed = status === "Completed" || status === "Failed";
    return reverse ? !isCompletedOrFailed : isCompletedOrFailed;
  };

  useEffect(() => {
    // This function is what you want to run at every interval
    if (
      (enrichmentDetailsData && handleEnrichmentStatusFailedOrCompleted(enrichmentDetailsData.status)) ||
      getEnrichmentDetailsByIdFn.isLoading
    ) {
      console.log("console in polling 1");
      return;
    }
    console.log("console in polling 2");
    const doPolling = () => {
      if (enrichmentDetailsData && enrichmentDetailsData.id && !getEnrichmentDetailsByIdFn.isLoading) {
        handleGetEnrichmentDetailsById(enrichmentDetailsData.id);
      }
    };

    // Start polling
    const intervalId = setInterval(doPolling, 5000); // 5000ms = 5 seconds

    if (enrichmentDetailsData && handleEnrichmentStatusFailedOrCompleted(enrichmentDetailsData.status)) {
      clearInterval(intervalId);
    }

    // Cleanup function to clear the interval when the component unmounts or the effect re-runs
    return () => clearInterval(intervalId);
  }, [enrichmentDetailsData, activeWorkspace && activeWorkspace.id, bulkSearchPayload]); // Empty dependency array means this effect runs only once on mount

  const getNonExistingCRMRecords = () => {
    return pushToCRMPayload
      .map((company) => {
        const filteredChildren = company.child_requests.filter((child) => {
          const crmRecords = getCRMSearchRecordByIdFlat(child?.contact_id || child?.person_id);

          return !(crmRecords && crmRecords.length > 0); // keep only if no existing CRM record
        });

        if (filteredChildren.length === 0) {
          return null; // root will be removed
        }

        const cleanedfilteredChildren = removeRecordExistsKeyFromChildren(filteredChildren);

        return {
          ...company,
          child_requests: cleanedfilteredChildren,
        };
      })
      .filter(Boolean);
  };
  const getCRMRecordPresenceStats = () => {
    let found = 0;
    let notFound = 0;
    if (pushToCRMPayload && pushToCRMPayload.length > 0) {
      pushToCRMPayload.forEach((company) => {
        company.child_requests.forEach((child) => {
          const id = child?.contact_id || child?.person_id;
          const crmRecords = getCRMSearchRecordByIdFlat(id);

          if (crmRecords && crmRecords.length > 0) {
            found += 1;
          } else {
            notFound += 1;
          }
        });
      });
    }

    return { found, notFound };
  };

  useEffect(() => {
    // Send handshake to opener
    if (window.opener) {
      window.opener.postMessage("ready_for_payload");
    }

    // Listen for payload from parent
    window.addEventListener("message", (event) => {
      // if (event.origin !== "https://dev.primerole.com:3000") return;
      const { payloadKey, payload } = event.data;

      if (payloadKey && payload) {
        localStorage.setItem(payloadKey, JSON.stringify(payload));
        console.log("Payload stored in localStorage:", payloadKey);

        // Get all push_to_crm_payload_ keys except the current one
        const allPayloadKeys = Object.keys(localStorage).filter(
          (key) => key.startsWith("push_to_crm_payload_") && key !== payloadKey
        );

        // Parse timestamp from key
        const keyTimestampPairs = allPayloadKeys.map((key) => {
          const parts = key.split("push_to_crm_payload_");
          const timestamp = parseInt(parts[1], 10);
          return { key, timestamp: isNaN(timestamp) ? 0 : timestamp };
        });

        // Sort by timestamp descending (most recent first)
        keyTimestampPairs.sort((a, b) => b.timestamp - a.timestamp);

        // Keep most recent 4 (plus the current one makes 5 total)
        const keysToDelete = keyTimestampPairs.slice(4); // not 5 since current one is excluded

        keysToDelete.forEach(({ key }) => {
          localStorage.removeItem(key);
          console.log("Deleted old payload:", key);
        });
      }
    });
  }, []);

  const removeRecordExistsKeyFromChildren = (childRequests = []) => {
    return childRequests.map(({ record_exists, ...rest }) => rest);
  };

  const renderCreateButton = () => {
    const hasUnrevealedRows = tableRowsWithoutIsRevealed.length > 0 && !skipMissingAlertDismissed;

    const noWritePermissionForPeople =
      savedPeopleConfigWithWritePermission &&
      !savedPeopleConfigWithWritePermission.find(
        (el) => payloadObject?.crm_object_api_name === el?.crm_object_api_name
      );

    const noReferenceFieldsForCompany =
      savedCompanyConfigWithWritePermission &&
      savedCompanyConfigWithWritePermission.length === 0 &&
      hasReferences &&
      pushToCRMPayload.every((el) => !el.reference_fields);

    const noNewRecords = getNonExistingCRMRecords().length === 0;

    const hasMissingReferences =
      hasReferences &&
      pushToCRMPayload.some((el) => {
        if (el.create_org) {
          return false;
        }
        if (!el.reference_fields) {
          const children = el.child_requests || [];

          // If all children exist, skip this block
          const allChildrenExist =
            children.length > 0 && children.every((child) => child.record_exists === true);
          if (allChildrenExist) return false;

          return true; // Only include if there's at least one child not existing
        }
        return false;
      });

    const hasPendingActions =
      getCompaniesWithMissingReferences(pushToCRMPayload) &&
      getCompaniesWithMissingReferences(pushToCRMPayload).length > 0;

    const validationErrors = getChildValidationErrors(pushToCRMPayload, tableHeads);
    const hasBlockingErrors = validationErrors.some((err) => err.validation_errors.length > 0);

    const isCreateButtonDisabled = hasBlockingErrors;

    console.log("isDisabled", {
      hasUnrevealedRows,
      noWritePermissionForPeople,
      noReferenceFieldsForCompany,
      hasMissingReferences,
      hasPendingActions,
      isCreateButtonDisabled,
    });

    const isDisabled =
      hasUnrevealedRows ||
      noWritePermissionForPeople ||
      noReferenceFieldsForCompany ||
      noNewRecords ||
      hasMissingReferences ||
      hasPendingActions ||
      isCreateButtonDisabled;

    // const isDisabled = false;

    const handleClick = () => {
      console.log("pushToCRMPayload", pushToCRMPayload);

      const filteredPayload = getNonExistingCRMRecords(); // remove null entries

      console.log("pushToCRMPayload filteredPayload", filteredPayload);

      const transformed = [];

      filteredPayload.forEach((item) => {
        const { reference_fields, child_requests, create_org, ...rest } = item;

        if (reference_fields && !create_org) {
          child_requests.forEach((child) => {
            transformed.push({
              ...child,
              reference_fields,
            });
          });
        } else if (
          (!hasReferences && !create_org) ||
          (savedCompanyConfigWithWritePermission && savedCompanyConfigWithWritePermission.length === 0)
        ) {
          child_requests.forEach((child) => {
            transformed.push({ ...child });
          });
        } else if (create_org) {
          transformed.push({ ...rest, child_requests });
        } else {
          transformed.push(item);
        }
      });

      console.log("pushToCRMPayload filteredPayload final", transformed);
      console.log("orgwise", bulkRecordDataOrgWise);

      // PostHog: Track create records click
      captureEvent("ECRM_BulkContacts_CreateRecordsClick", {
        records_count: getCRMRecordPresenceStats()?.notFound,
        companies_count: bulkRecordDataOrgWise?.length,
      });

      handleCreateBatchRecord(transformed);
    };

    return (
      <Button variant="purple-outline" type="button" onClick={handleClick} disabled={isDisabled}>
        {getCRMRecordPresenceStats()?.notFound > 0 ? (
          <>
            Create {getCRMRecordPresenceStats()?.notFound} Record
            {getCRMRecordPresenceStats()?.notFound > 1 ? "s" : ""}
          </>
        ) : (
          "Create Records"
        )}{" "}
        {isCRMCreateLoading && <div className="loader_circle ml-2"></div>}
      </Button>
    );
  };

  const getCompaniesWithMissingReferences = (pushToCRMPayload = []) => {
    if (!hasReferences) {
      return [];
    }
    const orgIdToNameMap = {};
    bulkRecordDataOrgWise.forEach((orgBlock) => {
      orgIdToNameMap[orgBlock.organization_id] = orgBlock.name || "Unknown Company";
    });

    return pushToCRMPayload
      .filter((item) => {
        if (item.type !== "company" || item?.create_org) return false;

        const children = item.child_requests;
        if (!Array.isArray(children) || children.length === 0) return false;

        const allChildrenExist = children.every((child) => child.record_exists === true);
        if (allChildrenExist) return false;

        const referenceFields = item.reference_fields;
        const isMissing = !referenceFields || Object.keys(referenceFields).length === 0;

        return isMissing;
      })
      .map((item) => ({
        organization_id: item.organization_id,
        orgName: orgIdToNameMap[item.organization_id] || "Unknown Company",
      }));
  };

  const areAllChildRecordsExisting = (orgId) => {
    const org = pushToCRMPayload.find((item) => item.organization_id === orgId);
    if (!org || !Array.isArray(org.child_requests)) return false;

    return org.child_requests.every((child) => child.record_exists === true);
  };

  function getChildValidationErrors(dataArray, keysArray) {
    // Create a map for quick access to required keys and their labels
    const requiredKeyMap = keysArray
      .filter((field) => field.required)
      .reduce((acc, field) => {
        acc[field.key] = field.label;
        return acc;
      }, {});

    const errors = [];

    dataArray.forEach((org) => {
      org.child_requests?.forEach((child) => {
        const input = child.input_fields;
        const crmRecordsWithError = getCRMCreateRecordById(child?.contact_id || child?.person_id);
        const crm_response_info = crmRecordsWithError?.crm_response_info || {};
        const personData =
          bulkRecordData &&
          bulkRecordData.length > 0 &&
          bulkRecordData.find((el) => {
            return el?.contact_id === child?.contact_id || el?.person_id === child?.person_id;
          });

        if (child?.record_exists) {
          return;
        }

        const validation_errors = [];

        // ✅ Check for input field validation
        if (input && typeof input === "object") {
          for (const [key, value] of Object.entries(input)) {
            if (
              requiredKeyMap.hasOwnProperty(key) &&
              (value === "" || value === null || value === undefined)
            ) {
              validation_errors.push({
                key,
                label: requiredKeyMap[key],
                required: true,
              });
            }
          }
        }
        if (
          (!input || typeof input !== "object") &&
          personData?.data &&
          typeof personData.data === "object"
        ) {
          for (const key of Object.keys(requiredKeyMap)) {
            const field = personData.data[key];
            const value = field?.value;

            if (value === "" || value === null || value === undefined) {
              validation_errors.push({
                key,
                label: requiredKeyMap[key],
                required: true,
              });
            }
          }
        }

        // ✅ If either validation errors OR crm_response_info has error
        if (validation_errors.length > 0 || crm_response_info.error) {
          errors.push({
            contact_id: child.contact_id,
            person_id: child.person_id,
            validation_errors,
            ...(crm_response_info.error && { crm_response_info }), // Only add crm_response_info if error exists
            ignoreCrmResponseError: validation_errors.length === 0,
          });
        }
      });
    });

    return errors;
  }

  function groupValidationErrorsByLabels(dataArray, keysArray) {
    const rawErrors = getChildValidationErrors(dataArray, keysArray);

    const groupMap = {};

    rawErrors.forEach((item) => {
      const labels = item.validation_errors?.map((e) => e.label).sort() || [];
      const crmError = item.crm_response_info?.error?.description || "";

      // Unique group key: labels + CRM error
      const groupKey = JSON.stringify({ labels, crmError });

      if (!groupMap[groupKey]) {
        groupMap[groupKey] = {
          labels,
          crmError,
          ids: [],
          count: 0,
        };
      }

      const id = item.person_id || item.contact_id;
      if (id) groupMap[groupKey].ids.push(id);
      groupMap[groupKey].count += 1;
    });

    return Object.values(groupMap);
  }

  const recordTypes = ["all_records", "action_required", "ready_to_add", "in_crm"];
  const [activeTypeOfRecord, setActiveTypeOfRecord] = useState("all_records");

  const isActiveTypeOfRecord = (type) => {
    return activeTypeOfRecord === type;
  };

  const switchToRecord = (type) => {
    setActiveTypeOfRecord(type);

    // PostHog: Track filter change
    captureEvent("ECRM_BulkContacts_FilterChange", {
      filter_type: type,
    });

    // Select all rows with data-record-type
    const allRows = document.querySelectorAll("[data-record-type]");

    allRows.forEach((row) => {
      const rowType = row.getAttribute("data-record-type");

      // Show the row if it matches current type or it's "all_records"
      if (type === "all_records" || rowType === type) {
        row.classList.remove("record__validation__row__hidden");
      } else {
        row.classList.add("record__validation__row__hidden");
      }
    });
    const containers = document.querySelectorAll(".records__row__container");

    containers.forEach((container) => {
      const allRowsInContainer = container.querySelectorAll(".record__validation__row");
      const hiddenRowsInContainer = container.querySelectorAll(
        ".record__validation__row.record__validation__row__hidden"
      );

      if (allRowsInContainer.length === hiddenRowsInContainer.length) {
        container.classList.add("records__row__container__hidden");
      } else {
        container.classList.remove("records__row__container__hidden");
      }
    });
  };

  if (
    createContactsV2andRevealContacts.isLoading ||
    revealContactFn.isLoading ||
    getEnrichmentDetailsByIdFn.isLoading ||
    isCRMBulkSearchLoading ||
    getCRMBulkRecordsFn.isLoading ||
    (enrichmentDetailsData && handleEnrichmentStatusFailedOrCompleted(enrichmentDetailsData.status, true))
  ) {
    return (
      <Layout>
        <div className="flex justify-center w-full h-[80vh] items-center">
          <div className="m-10">
            <div className="flex items-center space-x-3">
              {activeCRMIntegration?.integration?.key && (
                <Image src={`/images/crm/${activeCRMIntegration?.integration?.key}.svg`} className="w-14" />
              )}
              <Text size="lg">Processing. Do not close this page...</Text>
            </div>
            <div className="flex items-center space-x-10">
              <ul role="list" className="my-9 space-y-6">
                <li>
                  <div className="relative pb-3">
                    <span
                      className="absolute left-4 top-4 -ml-px h-full w-0.5 bg-gray-200"
                      aria-hidden="true"
                    ></span>
                    <div className="relative">
                      <div className="flex space-x-3 items-start">
                        <span className="h-8 w-8 rounded-full bg-gray-100 flex items-center justify-center">
                          <ChevronRightIcon />
                        </span>
                        <div className="">
                          <div className="">
                            <span className="text-[16px] text-gray-500 font-semibold block mb-2">
                              Revealing contacts
                            </span>
                            <Button
                              variant="outline"
                              className="rounded-md bg-white h-9 pointer-events-none space-x-3 w-auto"
                            >
                              {enrichmentDetailsData &&
                                handleEnrichmentStatusFailedOrCompleted(
                                  enrichmentDetailsData.status,
                                  true
                                ) && (
                                  <>
                                    <div className="loader_circle"></div>
                                    <span>Processing</span>
                                  </>
                                )}
                              {enrichmentDetailsData.status === "Completed" && (
                                <>
                                  <Image src={`/images/ext/check-green.svg`} />
                                  <span>Done</span>
                                </>
                              )}
                              {enrichmentDetailsData.status === "Failed" && (
                                <>
                                  <Image src={`/images/ext/cross-red-circle.svg`} />
                                  <span>Failed</span>
                                </>
                              )}
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="relative pb-3">
                    <span
                      className="absolute left-4 top-4 -ml-px h-full w-0.5 bg-gray-200"
                      aria-hidden="true"
                    ></span>
                    <div className="relative">
                      <div className="flex space-x-3 items-start">
                        <span className="h-8 w-8 rounded-full bg-gray-100 flex items-center justify-center">
                          <ChevronRightIcon />
                        </span>
                        <div className="">
                          <div className="">
                            <span className="text-[16px] text-gray-500 font-semibold block mb-2">
                              Search for existing records in CRM
                            </span>
                            <Button
                              variant="outline"
                              className="rounded-md bg-white h-9 pointer-events-none space-x-3 w-auto"
                            >
                              {handleEnrichmentStatusFailedOrCompleted(
                                enrichmentDetailsData.status,
                                true
                              ) && (
                                <>
                                  <span className="w-2 h-2 inline-block rounded-full bg-gray-500"></span>
                                  <span>Pending</span>
                                </>
                              )}
                              {handleEnrichmentStatusFailedOrCompleted(enrichmentDetailsData.status) &&
                                (getCRMBulkRecordsFn.isLoading ||
                                  isCRMBulkSearchLoading ||
                                  !isCRMBulkSearchFetched) && (
                                  <>
                                    <div className="loader_circle"></div>
                                    <span>Searching...</span>
                                  </>
                                )}
                              {isCRMBulkSearchFetched &&
                                handleEnrichmentStatusFailedOrCompleted(enrichmentDetailsData.status) &&
                                !isCRMBulkSearchLoading &&
                                !getCRMBulkRecordsFn.isLoading && (
                                  <>
                                    <Image src={`/images/ext/check-green.svg`} />
                                    <span>Done</span>
                                  </>
                                )}
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <div>
                <Image src={`/images/gym.svg`} />
              </div>
            </div>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div>
        {!creatingBatch ? (
          <>
            <div className="sm:flex sm:items-center">
              <div className="sm:flex-auto">
                <Text size="lg">
                  Review{" "}
                  {
                    savedPeopleConfig?.find(
                      (el) => payloadObject?.crm_object_api_name === el?.crm_object_api_name
                    )?.crm_object_label
                  }
                  {"s "}
                  to add to CRM
                </Text>
                <Text size="p" className="mt-1">
                  Please review the the following records. The records will be created as{" "}
                  {
                    savedPeopleConfig?.find(
                      (el) => payloadObject?.crm_object_api_name === el?.crm_object_api_name
                    )?.crm_object_label
                  }
                  {"s "}
                  in the CRM
                </Text>
              </div>
              <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">{renderCreateButton()}</div>
            </div>
            {!savedCompanyConfigWithWritePermission?.length &&
              !savedPeopleConfigWithWritePermission?.find(
                (el) => payloadObject?.crm_object_api_name === el?.crm_object_api_name
              ) && (
                <div className="mt-5">
                  <AlertTag
                    icon="/images/icons/untitledui/alert-warning.svg"
                    variant="warning"
                    heading={"Permissions denied"}
                    description={`You don’t have access to create or update Company and Person records. Click Manage Permissions to set the required access.`}
                    dismiss={false}
                    cta={
                      <>
                        <a
                          target="_blank"
                          href={`${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_APP_HOME}/${activeWorkspace?.slug}/settings/integrations/${activeCRMIntegration?.integration?.key}/${activeCRMIntegration?.id}/`}
                          asChild
                        >
                          <Button>Manage Permissions</Button>
                        </a>
                      </>
                    }
                  />
                </div>
              )}
            {tableRowsWithWithoutIsRevealed &&
              tableRowsWithWithoutIsRevealed.length > 0 &&
              tableRowsWithWithoutIsRevealed.filter((el) => !el.isRevealed)?.length > 0 &&
              !skipMissingContacts &&
              !skipMissingAlertDismissed && (
                <div className="mt-5">
                  <AlertTag
                    icon="/images/icons/untitledui/alert-warning.svg"
                    variant="warning"
                    heading={"Contact details missing"}
                    description={`It is recommended to reveal or add contact details before creating a CRM record`}
                    dismiss={false}
                    cta={
                      <>
                        <Button
                          className="h-9"
                          onClick={() => {
                            const skippedCount = tableRowsWithWithoutIsRevealed.filter((el) => !el.isRevealed)?.length;
                            // PostHog: Track skip contacts click
                            captureEvent("ECRM_BulkContacts_SkipContactsClick", {
                              skipped_count: skippedCount,
                            });
                            setSkipMissingContacts(true);
                            setSkipMissingAlertDismissed(true);
                          }}
                        >
                          Skip {tableRowsWithWithoutIsRevealed.filter((el) => !el.isRevealed)?.length} contact
                        </Button>
                        <Button
                          variant="ghost"
                          onClick={() => {
                            setSkipMissingAlertDismissed(true);
                          }}
                        >
                          Proceed
                        </Button>
                      </>
                    }
                  />
                </div>
              )}
            {getCRMRecordPresenceStats()?.notFound === 0 && getCRMRecordPresenceStats()?.found > 0 && (
              <Alert className="mt-3" variant={"success"}>
                <div className="flex items-start space-x-3">
                  <Image
                    src={"/images/icons/untitledui/alert-success.svg"}
                    width="30"
                    height="30"
                    className="no-invert inline-block -mt-1 -ml-1"
                  />
                  <div>
                    <AlertTitle className="text-gray-900 font-bold mb-2">
                      All records have been pushed to CRM or already exist
                    </AlertTitle>

                    <div className="">No action required. You can safely close this page.</div>
                  </div>
                </div>
              </Alert>
            )}

            {getCompaniesWithMissingReferences(pushToCRMPayload) &&
              getCompaniesWithMissingReferences(pushToCRMPayload).length > 0 && (
                <Alert className="mt-3" variant={"warning"}>
                  <div className="flex items-start space-x-3">
                    <Image
                      src={"/images/icons/untitledui/alert-warning.svg"}
                      width="30"
                      height="30"
                      className="no-invert inline-block -mt-1 -ml-1"
                    />
                    <div>
                      <AlertTitle className="text-gray-900 font-bold mb-2">
                        {getCompaniesWithMissingReferences(pushToCRMPayload).length} Action
                        {getCompaniesWithMissingReferences(pushToCRMPayload).length === 1 ? "" : "s"} Required
                      </AlertTitle>

                      <div className="">
                        {getCompaniesWithMissingReferences(pushToCRMPayload).map((el) => (
                          <div className="mt-3">
                            Choose a matching {payloadObject?.crm_object_api_name_company} for{" "}
                            <span className="font-bold">{el?.orgName}</span> or create a new{" "}
                            {payloadObject?.crm_object_api_name_company}.{" "}
                            <span
                              className="text-brand-800 font-bold cursor-pointer"
                              onClick={() => {
                                // PostHog: Track take action click
                                captureEvent("ECRM_BulkContacts_TakeActionClick", {
                                  company_name: el?.orgName,
                                  organization_id: el?.organization_id,
                                });

                                let button = document.getElementById(el?.organization_id);
                                if (button) {
                                  // button.click();
                                  button.scrollIntoView({ behavior: "smooth", block: "center" });
                                  button.classList.add("ring-2", "ring-warning-600");
                                  setTimeout(
                                    () => button.classList.remove("ring-2", "ring-warning-600"),
                                    2000
                                  );
                                }
                              }}
                            >
                              Take action
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </Alert>
              )}
            {getChildValidationErrors(pushToCRMPayload, tableHeads) &&
              getChildValidationErrors(pushToCRMPayload, tableHeads).length > 0 && (
                <>
                  <Alert className="mt-3" variant={"warning"}>
                    <div className="flex items-start space-x-3">
                      <Image
                        src={"/images/icons/untitledui/alert-warning.svg"}
                        width="30"
                        height="30"
                        className="no-invert inline-block -mt-1 -ml-1"
                      />
                      <div>
                        <AlertTitle className="text-gray-900 font-bold mb-2">
                          There are some issues with mentioned records.
                        </AlertTitle>

                        {groupValidationErrorsByLabels(pushToCRMPayload, tableHeads).map((group, idx) => (
                          <div key={idx} className="mt-3">
                            <span
                              className="text-brand-800 font-bold cursor-pointer"
                              onClick={() => {
                                const tr = document.getElementById(group?.ids?.[0]);
                                if (tr) {
                                  tr.scrollIntoView({ behavior: "smooth", block: "center" });
                                  tr.classList.add("outline", "outline-warning-600");
                                  setTimeout(
                                    () => tr.classList.remove("outline", "outline-warning-600"),
                                    2000
                                  );
                                }
                                captureEvent("ECRM_BulkContacts_ClickToFix", {
                                  error_labels: group.labels,
                                  records_count: group.count,
                                });
                              }}
                            >
                              Click here to fix
                            </span>{" "}
                            {group.crmError && (
                              <>
                                <TooltipWrapper content={group.crmError} contentClassName="w-[400px]">
                                  <b className="font-bold text-foreground">[ERROR]</b>
                                </TooltipWrapper>
                                {group.labels.length > 0 && <span className="mx-2">&</span>}
                              </>
                            )}
                            {group.labels.length > 0 && (
                              <span className="font-bold text-foreground">
                                [
                                <>
                                  {group.labels.map((label, index) => (
                                    <TooltipWrapper key={label} content="Field is required.">
                                      <span className="font-bold text-foreground">
                                        "{label}"{index !== group.labels.length - 1 && ", "}
                                      </span>
                                    </TooltipWrapper>
                                  ))}
                                </>
                                ]
                              </span>
                            )}{" "}
                            in <b>{group.count}</b> record{group.count > 1 ? "s" : ""}
                          </div>
                        ))}

                        <div className="">
                          {/* {getChildValidationErrors(pushToCRMPayload, tableHeads).map((el) => (
                            <div className="mt-3">
                              <span
                                className="text-brand-800 font-bold cursor-pointer"
                                onClick={() => {
                                  let tr =
                                    document.getElementById(el?.person_id) ||
                                    document.getElementById(el?.contact_id);
                                  if (tr) {
                                    tr.scrollIntoView({ behavior: "smooth", block: "center" });
                                    tr.classList.add("outline", "outline-warning-600");
                                    setTimeout(
                                      () => tr.classList.remove("outline", "outline-warning-600"),
                                      2000
                                    );
                                  }
                                }}
                              >
                                Click here to fix
                              </span>{" "}
                              {el?.crm_response_info?.error?.description && (
                                <span>
                                  <TooltipWrapper content={el?.crm_response_info?.error?.description}>
                                    <b className="font-bold text-foreground">[ERROR]</b>
                                  </TooltipWrapper>
                                  {el.validation_errors && el.validation_errors.length > 0 && (
                                    <span className="mx-2">&</span>
                                  )}
                                </span>
                              )}
                              {el.validation_errors && el.validation_errors.length > 0 && (
                                <span className="font-bold text-foreground">
                                  [
                                  <>
                                    {el.validation_errors.map((i, index) => (
                                      <TooltipWrapper content="Field is required.">
                                        <span className="font-bold text-foreground">
                                          "{i?.label}" {index !== el.validation_errors.length - 1 && ", "}
                                        </span>
                                      </TooltipWrapper>
                                    ))}
                                  </>
                                  ]
                                </span>
                              )}
                            </div>
                          ))} */}
                        </div>
                      </div>
                    </div>
                  </Alert>
                </>
              )}
            {(getCRMRecordPresenceStats()?.found > 0 || getCRMRecordPresenceStats()?.notFound > 0) && (
              <div className="inline-flex items-center mt-3">
                <div className="inline-flex rounded-md border bg-gray-iron-50 overflow-hidden p-1.5">
                  <span
                    onClick={() => {
                      switchToRecord("all_records");
                      captureEvent("ECRM_BulkContacts_SwitchRecordView", {
                        view: "all_records",
                      });
                    }}
                    className={`${isActiveTypeOfRecord("all_records") ? "bg-white rounded-md text-foreground border" : "cursor-pointer text-gray-600"} py-2 font-bold px-4  inline-flex items-center space-x-2`}
                  >
                    <span>All Records</span>{" "}
                    <Badge>
                      {getCRMRecordPresenceStats()?.found + getCRMRecordPresenceStats()?.notFound}
                    </Badge>
                  </span>

                  {getCRMRecordPresenceStats()?.notFound > 0 && (
                    <>
                      {getChildValidationErrors(pushToCRMPayload, tableHeads) &&
                        getChildValidationErrors(pushToCRMPayload, tableHeads).length > 0 && (
                          <span
                            onClick={() => {
                              switchToRecord("action_required");
                              captureEvent("ECRM_BulkContacts_SwitchRecordView", {
                                view: "action_required",
                              });
                            }}
                            className={`${isActiveTypeOfRecord("action_required") ? "bg-white rounded-md text-foreground border" : "cursor-pointer text-gray-600"} py-2 font-bold px-4  inline-flex items-center space-x-2`}
                          >
                            <Image src={`/images/ext/crm/error.svg`} className="" />
                            <span>
                              Action Required
                              {/* {getCRMRecordPresenceStats()?.notFound} record
                        {getCRMRecordPresenceStats()?.notFound > 1 ? "s" : ""} will be sent to CRM */}
                            </span>
                            {/* <Image
                        src={`/images/crm/${activeCRMIntegration?.integration?.key}-blue.svg`}
                        className="h-4"
                      /> */}
                            <Badge>{getChildValidationErrors(pushToCRMPayload, tableHeads).length}</Badge>
                          </span>
                        )}
                      {getCRMRecordPresenceStats()?.notFound -
                        getChildValidationErrors(pushToCRMPayload, tableHeads).length >
                        0 && (
                        <span
                          onClick={() => {
                            switchToRecord("ready_to_add");
                            captureEvent("ECRM_BulkContacts_SwitchRecordView", {
                              view: "ready_to_add",
                            });
                          }}
                          className={`${isActiveTypeOfRecord("ready_to_add") ? "bg-white rounded-md text-foreground border" : "cursor-pointer text-gray-600"} py-2 font-bold px-4  inline-flex items-center space-x-2`}
                        >
                          <span>
                            Ready to add
                            {/* {getCRMRecordPresenceStats()?.notFound} record
                        {getCRMRecordPresenceStats()?.notFound > 1 ? "s" : ""} will be sent to CRM */}
                          </span>
                          {/* <Image
                        src={`/images/crm/${activeCRMIntegration?.integration?.key}-blue.svg`}
                        className="h-4"
                      /> */}
                          <Badge>
                            {getCRMRecordPresenceStats()?.notFound -
                              getChildValidationErrors(pushToCRMPayload, tableHeads).length}
                          </Badge>
                        </span>
                      )}
                    </>
                  )}
                  {getCRMRecordPresenceStats()?.found > 0 && (
                    <>
                      <span
                        onClick={() => {
                          switchToRecord("in_crm");
                          captureEvent("ECRM_BulkContacts_SwitchRecordView", {
                            view: "in_crm",
                          });
                        }}
                        className={`${isActiveTypeOfRecord("in_crm") ? "bg-white rounded-md text-foreground border" : "cursor-pointer text-gray-600"} py-2 font-bold px-4  inline-flex items-center space-x-2`}
                      >
                        <Image
                          src={`/images/crm/${activeCRMIntegration?.integration?.key}-blue.svg`}
                          className="h-4"
                        />
                        <span>
                          {/* {getCRMRecordPresenceStats()?.found} record
                          {getCRMRecordPresenceStats()?.found > 1 ? "s" : ""} found */}
                          In CRM
                        </span>{" "}
                        {/* <Image src="/images/ext/crm/matched.svg" /> */}
                        {/* <Image
                          src={`/images/crm/${activeCRMIntegration?.integration?.key}-blue.svg`}
                          className="h-4"
                        /> */}
                        <Badge>{getCRMRecordPresenceStats()?.found}</Badge>
                      </span>
                    </>
                  )}
                </div>
              </div>
            )}

            {getCRMBulkRecordsFn.isLoading && <TableLoader />}
            {getCRMBulkRecordsFn.isSuccess && (
              <div>
                {platformFieldsPerson &&
                  platformFieldsPerson.length > 0 &&
                  bulkRecordDataOrgWise &&
                  bulkRecordDataOrgWise.length > 0 &&
                  bulkRecordDataOrgWise.map((org) => (
                    <PeopleOfCompany
                      platformFieldsPerson={platformFieldsPerson}
                      org={org}
                      query={payloadObject}
                      getOrgPayload={(data) => {
                        updateOrganizationById(org?.organization_id, data);
                      }}
                      getPeoplePayload={(data) => {
                        updatePersonById(data);
                      }}
                      removePersonFromPayload={(id) => {
                        removePersonByRecordId(id);
                      }}
                      hasReferences={hasReferences}
                      activeCRMIntegration={activeCRMIntegration}
                      allRecordsAlreadyPushed={areAllChildRecordsExisting(org?.organization_id)}
                      disableDelete={
                        pushToCRMPayload.length === 1 &&
                        pushToCRMPayload[0].child_requests &&
                        pushToCRMPayload[0].child_requests.length === 1
                          ? true
                          : false
                      }
                    />
                  ))}

                {tableRowsWithoutIsRevealed &&
                  tableRowsWithoutIsRevealed.length > 0 &&
                  skipMissingContacts && (
                    <div className="border border-gray-300 rounded-md overflow-x-scroll mt-5">
                      <div className="p-4 bg-gray-50 border-b border-gray-300 flex items-center">
                        <Cross2Icon
                          className="bg-white border p-1 rounded-md box-border mr-3 cursor-pointer"
                          width={24}
                          height={24}
                        />{" "}
                        <span>Skipping {tableRowsWithoutIsRevealed.length} contact from creation</span>
                      </div>
                      <table className="w-full border-collapse text-sm text-left">
                        <thead className="bg-gray-100 text-gray-700 font-semibold">
                          <tr>
                            <th className="px-4 py-2 border-b border-gray-300 border-r border-gray-200 whitespace-pre">
                              Name
                            </th>
                            {tableHeads &&
                              tableHeads.length > 0 &&
                              tableHeads.map((th) => (
                                <th className="px-4 py-2 border-b border-gray-300 border-r border-gray-200 whitespace-pre">
                                  {th?.label}
                                </th>
                              ))}
                          </tr>
                        </thead>
                        <tbody>
                          {tableRowsWithoutIsRevealed &&
                            tableRowsWithoutIsRevealed.length > 0 &&
                            tableRowsWithoutIsRevealed.map((item, index) => (
                              <tr className="hover:bg-gray-50">
                                <td className="px-4 py-2 border-b border-r border-gray-200">
                                  <div className="flex items-center whitespace-pre">
                                    {!item?.isRevealed && (
                                      <TooltipWrapper
                                        content="No contact details"
                                        className="w-[20px] h-[20px] mr-3"
                                      >
                                        <Image
                                          src="/images/icons/untitledui/alert-warning-outline.svg"
                                          className=""
                                        />
                                      </TooltipWrapper>
                                    )}
                                    <div className="inline-flex items-center">
                                      <div className="h-9 w-9 flex-shrink-0 items-center bg-gray-100 border border-border justify-center inline-flex rounded-full text-xs">
                                        {item?.first_name &&
                                          item?.last_name &&
                                          getInitials(`${item?.first_name} ${item?.last_name}`)}
                                      </div>
                                      <div className="ml-4">
                                        <div className="font-bold text-gray-800">
                                          {item?.first_name} {item?.last_name}{" "}
                                        </div>
                                        <div className="mt-0 text-gray-500">{item?.job_title}</div>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                {tableHeads &&
                                  tableHeads.length > 0 &&
                                  tableHeads.map((th) => (
                                    <td className="px-4 py-2 border-b border-r border-gray-200">
                                      <span className="inline-block border border-transparent whitespace-pre">
                                        {item[th?.key] || "-"}
                                      </span>
                                    </td>
                                  ))}
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                <div className="sm:flex sm:items-center mt-6">
                  <div className="sm:flex-auto"></div>
                  <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none space-x-2">{renderCreateButton()}</div>
                </div>
              </div>
            )}
          </>
        ) : (
          <>
            {createRecordBatchFn.isSuccess && (
              <>
                <div className="sm:flex sm:items-center">
                  <div className="sm:flex-auto">
                    <Text size="lg">Review CRM Records Created</Text>
                    <Text size="p" className="mt-1">
                      Review the records created and address errors, if any.
                    </Text>
                  </div>
                  <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
                    <Button
                      type="button"
                      onClick={() => {
                        navigate(`/${activeWorkspace?.slug}/companies/${payloadObject?.callbackUrl}`);
                        // window.parent.postMessage(
                        //   {
                        //     type: "CONTACTS_PUSHED_TO_CRM",
                        //   },
                        //   "*"
                        // );
                      }}
                    >
                      Done
                    </Button>
                  </div>
                </div>

                <ResponseTable
                  tableHeads={tableHeads}
                  tableRows={tableRowsWithSuccessResponse}
                  type={"success"}
                />
                <ResponseTable
                  tableHeads={tableHeads}
                  tableRows={tableRowsWithErrorResponse}
                  type={"error"}
                />
              </>
            )}
            {createRecordBatchFn.isLoading && (
              <div>
                <div className="sm:flex sm:items-center">
                  <div className="sm:flex-auto">
                    <Text size="lg">Creating contacts in CRM</Text>
                    <Text size="p" className="mt-1">
                      Records are getting created in your CRM. Don’t close this screen.
                    </Text>
                  </div>
                </div>
                <div className="flex justify-center flex-col items-center space-y-3 h-[60vh]">
                  <div className="loader_circle loader_purple"></div>
                  <span className="text-lg text-gray-900">
                    {" "}
                    Creating {tableRowsWithWithoutIsRevealed?.length} contacts. This might take a minute.
                  </span>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </Layout>
  );
}
